var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 17C7.9625 17 8.75 16.235 8.75 15.3H5.25C5.25 16.235 6.0375 17 7 17Z",
  fill: "#F3BC01"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.25 12.75H13.125C13.6063 12.75 14 13.1325 14 13.6C14 14.0675 13.6063 14.45 13.125 14.45H0.875C0.39375 14.45 0 14.0675 0 13.6C0 13.1325 0.39375 12.75 0.875 12.75H1.75V6.8C1.75 4.4285 3.42125 2.431 5.6875 1.87V1.275C5.6875 0.5695 6.27375 0 7 0C7.72625 0 8.3125 0.5695 8.3125 1.275V1.87C10.5787 2.431 12.25 4.4285 12.25 6.8V12.75Z",
  fill: "#F3BC01"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.52635 10.8551L10.3055 7.08427C10.5659 6.82444 10.5659 6.40471 10.2988 6.14488C10.0384 5.88506 9.61782 5.88506 9.35742 6.14488L6.05228 9.44275L4.63676 8.03032C4.37636 7.77049 3.95571 7.77049 3.6953 8.03032C3.4349 8.29015 3.4349 8.70988 3.6953 8.96972L5.58489 10.8551C5.8453 11.115 6.26595 11.115 6.52635 10.8551Z",
  fill: "white"
});

function SvgIcBellSubscribed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBellSubscribed);
export default __webpack_public_path__ + "static/media/ic_bell_subscribed.b327f353fbbfd601259f45488eaf65b2.svg";
export { ForwardRef as ReactComponent };